import React, { useState, useEffect, useRef } from "react";
import Layout from "../common/Layout";
import Leftsidebar from "../sidebar/leftsidebar";
import LeftResponsivesidebar from "../sidebar/left-responsive";
import Headmenu from "../sidebar/headmenu";
import {
  BsCameraVideoOffFill,
  BsMicMute,
  BsMicMuteFill,
  BsFillCameraVideoFill,
} from "react-icons/bs";
import { Switch } from "@headlessui/react";
import Webcam from "react-webcam";
import { TbWorld } from "react-icons/tb";

import like from "../../assets/images/icons/like.png";
import { IoBagHandle } from "react-icons/io5";

export const GoliveProduct = () => {
  const [cameraOn, setCameraOn] = useState(false);
  const [micOn, setMicOn] = useState(false);
  const [commentsEnabled, setCommentsEnabled] = useState(false);
  const webcamRef = useRef(null);

  const [deviceId, setDeviceId] = React.useState({});
  const [devices, setDevices] = React.useState([]);

  const handleDevices = React.useCallback(
    (mediaDevices) =>
      setDevices(mediaDevices.filter(({ kind }) => kind === "videoinput")),
    [setDevices]
  );

  React.useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then(handleDevices);
  }, [handleDevices]);

  console.log(webcamRef);
  console.log(deviceId);

  const [isLive, setIsLive] = useState(false); // Tracks Go Live state

  const [chatMessages, setChatMessages] = useState([]);

  const liveChatMessages = [
    {
      id: 1,
      name: "Ralph Edwards",
      time: "12:20 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 2,
      name: "Ralph Edwards",
      time: "12:21 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 3,
      name: "Ralph Edwards",
      time: "12:22 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 4,
      name: "Ralph Edwards",
      time: "12:20 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 5,
      name: "Ralph Edwards",
      time: "12:21 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 6,
      name: "Ralph Edwards",
      time: "12:22 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 7,
      name: "Ralph Edwards",
      time: "12:20 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 8,
      name: "Ralph Edwards",
      time: "12:21 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 9,
      name: "Ralph Edwards",
      time: "12:22 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
  ];

  const comments = [
    {
      id: 1,
      name: "Ralph Edwards",
      time: "12:30 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.",
      avatar: "/image/profilepic.png",
    },
    {
      id: 2,
      name: "Ralph Edwards",
      time: "12:30 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.",
      avatar: "/image/profilepic.png",
    },
  ];

  const products = [
    {
      id: 1,
      image: "https://via.placeholder.com/224x391", // replace with actual product image url
      name: "ADIDAS 4DFWD X PARLEY RUNNING SHOES",
      originalPrice: 444,
      discountedPrice: 333.2,
      qtySold: 10,
      qtyOutOf: 25,
      countdown: "01:00:00",
    },
    {
      id: 1,
      image: "https://via.placeholder.com/224x391", // replace with actual product image url
      name: "ADIDAS 4DFWD X PARLEY RUNNING SHOES",
      originalPrice: 444,
      discountedPrice: 333.2,
      qtySold: 10,
      qtyOutOf: 25,
      countdown: "01:00:00",
    },
    {
      id: 1,
      image: "https://via.placeholder.com/224x391", // replace with actual product image url
      name: "ADIDAS 4DFWD X PARLEY RUNNING SHOES",
      originalPrice: 444,
      discountedPrice: 333.2,
      qtySold: 10,
      qtyOutOf: 25,
      countdown: "01:00:00",
    },
    {
      id: 1,
      image: "https://via.placeholder.com/224x391", // replace with actual product image url
      name: "ADIDAS 4DFWD X PARLEY RUNNING SHOES",
      originalPrice: 444,
      discountedPrice: 333.2,
      qtySold: 10,
      qtyOutOf: 25,
      countdown: "01:00:00",
    },
    {
      id: 1,
      image: "https://via.placeholder.com/224x391", // replace with actual product image url
      name: "ADIDAS 4DFWD X PARLEY RUNNING SHOES",
      originalPrice: 444,
      discountedPrice: 333.2,
      qtySold: 10,
      qtyOutOf: 25,
      countdown: "01:00:00",
    },
    {
      id: 1,
      image: "https://via.placeholder.com/224x391", // replace with actual product image url
      name: "ADIDAS 4DFWD X PARLEY RUNNING SHOES",
      originalPrice: 444,
      discountedPrice: 333.2,
      qtySold: 10,
      qtyOutOf: 25,
      countdown: "01:00:00",
    },
    {
      id: 1,
      image: "https://via.placeholder.com/224x391", // replace with actual product image url
      name: "ADIDAS 4DFWD X PARLEY RUNNING SHOES",
      originalPrice: 444,
      discountedPrice: 333.2,
      qtySold: 10,
      qtyOutOf: 25,
      countdown: "01:00:00",
    },
    {
      id: 1,
      image: "https://via.placeholder.com/224x391", // replace with actual product image url
      name: "ADIDAS 4DFWD X PARLEY RUNNING SHOES",
      originalPrice: 444,
      discountedPrice: 333.2,
      qtySold: 10,
      qtyOutOf: 25,
      countdown: "01:00:00",
    },
  ];

  return (
    <div className="dashboard w-full min-h-screen flex">
      <Leftsidebar />

      <main className="flex-1 min-w-0 bg-gray-100 p-4 md:p-6">
        <LeftResponsivesidebar />
        <Headmenu />
        <div className="mt-6 w-full  flex flex-col lg:flex-row gap-4">
          <div className="bg-[#EBF8ED] w-full lg:w-[70%]">
            <div className="w-[100%] flex">
              <div
                className={`bg-black relative rounded-lg h-[400px] flex flex-col justify-center items-center text-white ${
                  commentsEnabled ? "w-[100%]" : "w-[100%]"
                }`}
              >
                {cameraOn ? (
                  <Webcam
                    ref={webcamRef}
                    audio={false}
                    videoConstraints={{ deviceId: devices.deviceId }}
                    className="rounded-md w-full max-w-[100%]  h-[400px]"
                  />
                ) : (
                  <div className="flex flex-col justify-center items-center text-white">
                    <div className="absolute top-0 left-0 px-5 bg-[#D9D9D980] py-2 rounded-br-3xl">
                      <div className="flex gap-3 py-2 ">
                        <div className="bg-white p-2  w-[50px] h-[50px] rounded-full">
                          <img
                            src="/image/wanchain.png"
                            alt="logo"
                            className="w-[40px] h-[40px] object-contain"
                          />
                        </div>
                        <div className="text-black ">
                          <p className="font-semibold text-xl"> SKY Products</p>
                          <p className="text-md">{"27 Jan 2025, 12:30 PM"}</p>
                        </div>
                      </div>
                    </div>
                    <div className="text-4xl mb-4">
                      <BsCameraVideoOffFill />
                    </div>
                    <p className="text-lg font-semibold">
                      Allow Access To Camera
                    </p>
                    <p className="text-sm text-gray-400 text-center max-w-md mt-2 px-4">
                      Your browser is not allowing Live Producer access to your
                      camera. Go to your browser settings and allow camera
                      permission.
                    </p>
                    <button
                      onClick={() => window.location.reload()}
                      className="mt-4 bg-gray-300 px-4 py-2 rounded"
                    >
                      Retry
                    </button>
                  </div>
                )}
              </div>
            </div>

            <div className="mt-4 flex flex-wrap gap-3 justify-between items-center  p-4 rounded ">
              <div className="flex gap-4 items-center ">
                <button
                  onClick={() => {
                    setCameraOn((prev) => !prev);

                    // OPTIONAL: stop the stream when turning off
                    const videoEl = webcamRef.current?.video;
                    if (videoEl && videoEl.srcObject) {
                      const stream = videoEl.srcObject;
                      const tracks = stream.getTracks();
                      tracks.forEach((track) => track.stop());
                    }
                  }}
                  className="text-xl bg-white rounded-full p-3"
                >
                  {cameraOn ? (
                    <BsFillCameraVideoFill className="text-gray-400" />
                  ) : (
                    <BsCameraVideoOffFill className="text-gray-400" />
                  )}
                </button>
                <button
                  onClick={() => setMicOn(!micOn)}
                  className="text-xl bg-white rounded-full p-3"
                >
                  {micOn ? <BsMicMuteFill /> : <BsMicMute />}
                </button>
                <div className="flex items-center gap-2">
                  <Switch
                    checked={commentsEnabled}
                    onChange={setCommentsEnabled}
                    className={`${
                      commentsEnabled ? "bg-green-800" : "bg-gray-300"
                    } relative inline-flex h-6 w-11 items-center rounded-full`}
                  >
                    <span
                      className={`${
                        commentsEnabled ? "translate-x-6" : "translate-x-1"
                      } inline-block h-4 w-4 transform bg-white rounded-full transition`}
                    />
                  </Switch>
                  <span className="text-sm">Comments</span>
                </div>
              </div>
            </div>
          </div>
          <div className="golive-chatbox w-full max-lg:max-w-none lg:w-auto bg-[#F9FAFB] p-4 mb-5 h-[550px] rounded-lg relative">
            <div className="absolute top-0 right-0 w-full h-[50%]  rounded-lg z-10 bg-gradient-to-t from-[#ffffff00] to-[#ffffff] pointer-events-none" />

            <div className="h-full overflow-y-auto space-y-4 relative scrollbar-hidden">
              {/* White Shade Blur Effect */}

              {liveChatMessages.map((chat) => (
                <div key={chat.id} className="px-3 py-1 rounded-md">
                  <div className="flex">
                    <div>
                      <img
                        src="/image/profilepic.png"
                        alt={chat.name}
                        className="w-9 rounded-full"
                      />
                    </div>
                    <div className="pl-2">
                      <p className="font-semibold">{chat.name}</p>
                      <p className="text-[8px] text-[#000000]">{chat.time}</p>
                    </div>
                  </div>
                  <p className="text-[12px] break-words pt-2">{chat.message}</p>
                  <hr className="mt-2 pt-[1px] bg-[#D9D9D9]" />
                </div>
              ))}
            </div>
            {/* Add Comment Input */}
            <div className="flex items-center mt-4 w-full absolute bottom-2 right-0">
              <div className="relative flex flex-1 min-w-0 mx-2">
                <input
                  type="text"
                  placeholder="Add a comment"
                  className="flex-1 min-w-0 p-3 border border-gray-300 rounded-full focus:outline-none"
                />
                <button className="bg-blue-500 text-white px-4 py-2 rounded-full go-to-live-CTA absolute right-1 top-1">
                  Send
                </button>
              </div>
              {/* Show Like Button only when live */}
              {isLive && (
                <button className="shrink-0 bg-[#BE1F2E] text-white px-3 mx-2 py-3 rounded-full">
                  <img src={like} alt="Like" />
                </button>
              )}
            </div>
            {/* Footer */}
            <div className="lg:hidden">
              <div className="copy-rights pb-5 text-center text-sm text-[#095228]">
                © 2025 Nyawoo. All Rights Reserved
              </div>
            </div>
          </div>
        </div>
        <div>
          <main className="py-6 px-4 ">
            {" "}
            {/* Products Cards */}{" "}
            <div className="flex overflow-x-auto gap-4 w-full max-w-[1120px] scrollbar-hide">
              {" "}
              {products.map((product) => (
                <div
                  key={product.id}
                  className="min-w-[200px] border-2 border-purple-600 rounded-md p-1 bg-white flex-shrink-0"
                >
                  {" "}
                  <div className="bg-[#eceef0] relative rounded-xl">
                    {" "}
                    <p className="absolute top-1 left-1 p-2 rounded-tl-3xl rounded-br-3xl bg-red-700 text-white text-xs font-semibold px-3 rounded">
                      {" "}
                      12% Offer{" "}
                    </p>{" "}
                    <img
                      src={"/image/shoeimg.png"}
                      alt={product.name}
                      className="w-full h-48 object-contain"
                    />{" "}
                    <p className="bg-[#98911f] absolute right-0 bottom-1 text-white text-xs text-center rounded-xl px-2 py-[3px] my-1 mr-4">
                      {" "}
                      {product.countdown}{" "}
                    </p>{" "}
                  </div>{" "}
                  <div className="p-2 space-y-2">
                    {" "}
                    <h4 className="text-[13px] font-bold">
                      {product.name}
                    </h4>{" "}
                    <p className="text-xs font-semibold mr-3 line-through text-gray-400">
                      {" "}
                      ${product.originalPrice}{" "}
                    </p>{" "}
                    <div className="flex justify-between items-center">
                      {" "}
                      <p className="text-[15px] font-bold text-[#095228]">
                        {" "}
                        ${product.discountedPrice}{" "}
                      </p>{" "}
                      <button className="flex gap-2 items-center bg-[#161F28] text-white rounded-xl text-xs mt-2 p-2">
                        {" "}
                        <IoBagHandle className="text-lg" /> <span>BUY NOW</span>{" "}
                      </button>{" "}
                    </div>{" "}
                  </div>{" "}
                </div>
              ))}{" "}
            </div>{" "}
          </main>
        </div>
      </main>
    </div>
  );
};
